import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import CodeServiceModel from '@/models/CodeServiceModel';

@model.cacheDuration()
@model.urnResource('code_usage_status')
@doc.path('/code_usage_statuses/{?id}')
export default class CodeUsageStatusModel extends CodeServiceModel {
	private declare _tsFilters: {
		'reference': Code_CodeUsageStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Code_CodeUsageStatusReference;
	
	public get fullName() {
		switch (this.reference) {
			case 'waiting':
				return 'Non';
			case 'used':
				return 'Oui';
		}
	}
	
	public get color() {
		switch (this.reference) {
			case 'waiting':
				return 'purple';
			case 'used':
				return 'blue';
		}
	}
}